var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1798_2140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 84H72V102.596C72 102.968 71.7879 103.325 71.4103 103.589C71.0327 103.852 70.5206 104 69.9867 104H50.0533C49.7856 104.003 49.5195 103.97 49.2706 103.901C49.0217 103.832 48.795 103.729 48.6038 103.598C48.4126 103.468 48.2607 103.312 48.157 103.14C48.0533 102.967 47.9999 102.782 48 102.596V84Z",
    fill: "#DAD7D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0002 22.5196C52.6849 22.5231 45.6702 25.4307 40.4974 30.6034C35.3247 35.7761 32.4171 42.7909 32.4136 50.1062C32.4136 65.3329 48.0002 71.4262 48.0002 83.9996H72.0002C72.0002 71.4129 87.6269 65.3329 87.6269 50.0929C87.6252 46.4679 86.909 42.8788 85.5193 39.5308C84.1297 36.1827 82.0938 33.1414 79.5281 30.5806C76.9624 28.0199 73.9171 25.9899 70.5664 24.6067C67.2157 23.2235 63.6252 22.5143 60.0002 22.5196Z",
    fill: "#FFCC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 25.1855C66.6071 25.1926 72.9415 27.8204 77.6134 32.4922C82.2853 37.1641 84.913 43.4985 84.9201 50.1055C84.9201 57.1722 81.1334 61.9989 77.1068 67.1322C73.7868 71.3722 70.3467 75.7589 69.4934 81.3455H50.5067C49.6534 75.7589 46.2267 71.3722 42.8934 67.1322C38.8934 61.9989 35.0801 57.1722 35.0801 50.1055C35.0871 43.4985 37.7149 37.1641 42.3868 32.4922C47.0587 27.8204 53.3931 25.1926 60.0001 25.1855Z",
    fill: "#FAE18A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0004 62.2263C66.6941 62.2263 72.1204 56.8 72.1204 50.1063C72.1204 43.4126 66.6941 37.9863 60.0004 37.9863C53.3067 37.9863 47.8804 43.4126 47.8804 50.1063C47.8804 56.8 53.3067 62.2263 60.0004 62.2263Z",
    fill: "#FFEEB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1773 90.3031L48.7006 90.4679C47.8762 90.4748 47.1078 90.8834 46.5647 91.604C46.0215 92.3245 45.748 93.298 45.8043 94.3101C45.8606 95.3223 46.2421 96.2903 46.8649 97.0012C47.4877 97.712 48.3008 98.1075 49.1252 98.1007L71.6136 98.015C72.0337 98.0313 72.4471 97.9436 72.8288 97.7571C73.2105 97.5706 73.5528 97.2891 73.8351 96.9296C74.1174 96.57 74.334 96.1398 74.4718 95.6647C74.6096 95.1895 74.6658 94.6792 74.6371 94.1643C74.6083 93.6495 74.4953 93.1406 74.3046 92.6683C74.1139 92.1959 73.8496 91.7698 73.5275 91.4154C73.2054 91.0611 72.832 90.7857 72.4299 90.6059C72.0277 90.4261 71.605 90.3455 71.187 90.369L71.1773 90.3031Z",
    fill: "#BDBCB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.947 -0.0136719H57.0537V13.7597H62.947V-0.0136719Z",
    fill: "#FFCC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0321 12.0001L22 16.3164L32.0746 25.7278L36.1068 21.4115L26.0321 12.0001Z",
    fill: "#FFCC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0748 12.0001L102.107 16.3164L92.0323 25.7278L88.0002 21.4115L98.0748 12.0001Z",
    fill: "#FFCC04"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1798_2140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasic);
export default __webpack_public_path__ + "static/media/basic.d5b6fe5ccd81a5781f68943c1786de0f.svg";
export { ForwardRef as ReactComponent };